import { Tooltip } from 'bootstrap';

export default function initTooltips() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        Tooltip.getOrCreateInstance(el);
    });
}
